/**
 * NOT_PUBLISH 未發佈
 * BEFORE 未開始
 * RUNNING 運行中
 * SUSPEND 暫停
 * END 結束
 */

export const gameRunningStatuses = {
    NOT_PUBLISH: 'not-publish',
    BEFORE: 'before',
    RUNNING: 'running',
    SUSPEND: 'suspend',
    END: 'end'
};
